/**
 * Enumeration of possible catalogue product statuses.
 */
export const enum CatalogueProductStatus {

    PUBLISHED = 'published',
    UNPUBLISHED = 'unpublished',

}
